import { Router } from 'aurelia-router';
import { autoinject, bindable } from 'aurelia-framework';
import { IdentityHelpers } from '@identity/helpers';
import { Repository } from '@data/repository';
import { IEntityEnrollment } from '../../interfaces/interfaces';
import parse from 'date-fns/parse';
import isAfter from 'date-fns/isAfter';
import isBefore from 'date-fns/isBefore';
import isEqual from 'date-fns/isEqual';
declare const LIVE_URL_IMAGES: string; // The value is supplied by Webpack during the build

@autoinject
export class NavPublic {

  private router: Router;
  private identity: IdentityHelpers;
  private basketId: string | null = null;
  private joinInviteId: string | null = null;
  private joinToken: string | null = null;
  @bindable spaName: string = '';
  private modal: HTMLElement | null = null;
  private modalParent: HTMLElement | null = null;
  private body: HTMLElement | null = null;
  private clickEvent: any = null;
  private messageEvent: any = null;
  private inviteRequested: boolean = false;
  private repository: Repository;
  private breezeMgr!: breeze.EntityManager;
  private enrollment: any;
  private hasEnrollment: boolean = false;
  private enrollmentOpen: boolean = false;
  private isCommunityMember: boolean = false;
  private liveUrlImages: string = LIVE_URL_IMAGES;

  getCookie(name: String) {
    const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
    return v ? v[2] : null;
  }

  constructor(router: Router, identity: IdentityHelpers, repository: Repository) {
    this.router = router;
    this.identity = identity;
    this.repository = repository;
    this.breezeMgr = this.repository.breezeManager;
  }

  openInviteModal() {
    if (this.modal && this.body) {
      this.modal.classList.add('invoked');
      this.body.classList.add('modal-overlay');
      this.body.classList.add('noscroll');

      setTimeout(
        () => {
          if (this.modal) {
            this.modal.classList.remove('loaded');
          }
        },
        400,
      );
    }
  }

  closeInviteModal(event: any) {
    const theevent = event || window.event;
    const { target: eventtarget } = theevent;

    if (eventtarget.classList.contains('invite-modal-container') ||
      eventtarget.classList.contains('invite-modal-close')) {
      if (this.modal && this.body) {
        this.modal.classList.remove('invoked');
        this.body.classList.remove('modal-overlay');
        this.body.classList.remove('noscroll');

        setTimeout(
          () => {
            if (this.modal) {
              this.modal.classList.add('loaded');
            }
          },
          400,
        );
      }
    }
  }

  attached() {
    this.modal = document.querySelector('#GetYourInvite');
    this.modalParent = document.querySelector('#modalParent');
    this.body = document.querySelector('body');

    if (this.modal) {
      this.modal.classList.add('loaded');
    }

    if (this.modalParent) {
      this.clickEvent = this.closeInviteModal.bind(this);
      this.modalParent.addEventListener('click', this.clickEvent);
    }

  }

  processMessage(e: any) {
    console.log('Message received');
    console.log(e.data);

    if (e.data.hasOwnProperty('frameHeight')) {

      console.log(e.data.frameHeight);

      const iframe: HTMLIFrameElement | null = <HTMLIFrameElement | null>
        document.getElementById('inviteIframe');
      if (iframe) {
        iframe.style.height = `${e.data.frameHeight}px`;
      }
    }

    if (e.data.hasOwnProperty('submitted')) {
      this.inviteRequested = true;
    }
  }

  public async bind() {

    console.log('Bind nav');
    console.log(this.spaName);

    this.basketId = this.getCookie('cpt-cart');
    this.joinInviteId = this.getCookie('cpt-join-InviteId');
    this.joinToken = this.getCookie('cpt-join-Token');

    this.messageEvent = this.processMessage.bind(this);
    window.addEventListener('message', this.messageEvent);

    this.enrollment = this.breezeMgr.getEntities('ProductEnrollment');
    this.hasEnrollment = this.enrollment.length > 0;

    if (this.hasEnrollment) {
      const today: Date = new Date();
      const openDate: Date = parse(
        this.enrollment[0].friendlyOpenDate, 'dd/MM/yyyy', new Date());
      this.enrollmentOpen = isAfter(today, openDate) || isEqual(today, openDate);
    }

    this.isCommunityMember = this.identity.user && this.identity.user.IsAuthenticated &&
      this.identity.user.Person !== null && (this.identity.user.Person.isActiveCommunity ||
      !this.identity.user.CommunityExpired);

    return Promise.resolve();
  }

  detached() {
    if (this.clickEvent && this.modalParent) {
      this.modalParent.removeEventListener('click', this.clickEvent);
      this.clickEvent = null;
    }
    if (this.messageEvent) {
      window.removeEventListener('message', this.messageEvent);
      this.messageEvent = null;
    }
  }

}
